<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<div class="card-header">
					<el-form :inline="true" :model="formInline" class="demo-form-inline" ref="searchform">
						<el-form-item :label="$t('goods.name')">
							<el-input v-model="formInline.name" :placeholder="$t('goods.name')"></el-input>
						</el-form-item>
						<el-form-item :label="$t('goods.status')">
							<el-select v-model="formInline.status" :placeholder="$t('goods.status')">
								<el-option :label="$t('goods.all')" value=""></el-option>
								<el-option :label="$t('goods.pending')" :value="1"></el-option>
								<el-option :label="$t('goods.published')" :value="2"></el-option>
								<el-option :label="$t('goods.off')" :value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('goods.category')">
							<el-select v-model="formInline.category_id" :placeholder="$t('goods.category')">
								<el-option v-for="item in categories" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="search">{{ $t('device.inquire') }}</el-button>
							<el-button @click="reset">{{ $t('device.reset') }}</el-button>
						</el-form-item>
					</el-form>
					<el-button type="primary" @click="handleEdit">{{ $t('goods.add') }}</el-button>
				</div>
			</template>

			<el-table :data="tableData" border stripe>
				<el-table-column prop="id" label="ID" width="60"></el-table-column>
				<el-table-column prop="name" :label="$t('goods.name')"></el-table-column>
				<el-table-column prop="category_name" :label="$t('goods.category')"></el-table-column>
				<el-table-column prop="model_name" :label="$t('goods.model')"></el-table-column>
				<el-table-column prop="goods_id" :label="$t('goods.goods_id')"></el-table-column>

				<el-table-column :label="$t('goods.logo')">
					<template #default="{row}">
						<a :href="row.logo" target="_blank" class="product-image-link">
							<img class="product-image" :src="row.logo" :alt="row.name"
								style="width:100px;height:100px;object-fit:contain"
								@error="$event.target.style.display='none'">

						</a>
					</template>
				</el-table-column>
				<el-table-column prop="desc" :label="$t('goods.desc')"></el-table-column>
				<el-table-column :label="$t('goods.file')">
					<template #default="{row}">
						<a :href="row.file" target="_blank" v-if="row.file">{{$t('goods.view_file')}}</a>
					</template>
				</el-table-column>
				<el-table-column :label="$t('goods.video_file')">
					<template #default="{row}">
						<a :href="row.video_file" target="_blank" v-if="row.video_file">{{$t('goods.view_file')}}</a>
					</template>
				</el-table-column>
				<el-table-column prop="card_type" :label="$t('goods.card_type')" width="300">
					<template #default="{row}">
						<el-tag v-for="type in getSortedCardTypes(row.card_type_arr)" :key="type" style="margin-right:5px;">
							{{ getCardTypeName(type) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="status_text" :label="$t('goods.status')"></el-table-column>
				<el-table-column prop="create_at" :label="$t('device.creation_time')"></el-table-column>
				<el-table-column :label="$t('device.operating')" width="200">
					<template #default="{row}">
						<el-button size="small" @click="handleEdit(row)">{{ $t('device.edit') }}</el-button>
						<el-button size="small" :type="row.status === 2 ? 'danger' : 'success'"
							@click="toggleStatus(row)">
							{{ row.status === 2 ? $t('goods.off') : $t('goods.publish') }}
						</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-dialog :title="editTitle" v-model="dialogVisible" width="40%">
				<el-form :model="editForm" label-width="120px">
	
					<el-form-item :label="$t('goods.name')">
						<el-input v-model="editForm.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('goods.category')">
						<el-select v-model="editForm.category_id">
							<el-option v-for="item in categories" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('goods.model')">
						<el-select v-model="editForm.goods_id" :placeholder="$t('goods.select_model')">
							<el-option :label="$t('goods.all')" :value="0"></el-option>
							<el-option v-for="item in models" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('goods.desc')">
						<el-input v-model="editForm.desc" type="textarea"></el-input>
					</el-form-item>
					<el-form-item :label="$t('goods.card_type')">
						<el-checkbox-group v-model="editForm.card_type_arr">
							<el-checkbox v-for="item in cardTypeOptions" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item :label="$t('goods.logo')">
						<el-upload action="/common/upload" :on-success="handleLogoUpload" :show-file-list="false">
							<el-button type="primary">{{ $t('goods.upload_logo') }}</el-button>
						</el-upload>
						<a v-if="editForm.logo" :href="editForm.logo" target="_blank" class="el-button el-button--text"
							style="margin-left:10px;">{{ $t('goods.view_file') }}</a>
						<img v-if="editForm.logo" :src="editForm.logo" style="width:50px;height:50px;margin-left:10px;">

					</el-form-item>
					<el-form-item :label="$t('goods.file')">
						<el-upload action="/common/upload" :on-success="handleFileUpload" :show-file-list="false">
							<el-button type="primary">{{ $t('goods.upload_file') }}</el-button>
						</el-upload>
						<a v-if="editForm.file" :href="editForm.file" target="_blank" class="el-button el-button--text"
							style="margin-left:10px;">{{ $t('goods.view_file') }}</a>
					</el-form-item>
					<!-- 新增的视频文件上传 -->
					<el-form-item :label="$t('goods.video_file')">
						<el-upload action="/common/upload" :on-success="handleVideoFileUpload" :show-file-list="false">
							<el-button type="primary">{{ $t('goods.upload_file') }}</el-button>
						</el-upload>
						<a v-if="editForm.video_file" :href="editForm.video_file" target="_blank" class="el-button el-button--text"
							style="margin-left:10px;">{{ $t('goods.view_file') }}</a>
					</el-form-item>
				</el-form>
				<template #footer>
					<el-button @click="dialogVisible = false">{{ $t('device.cancel') }}</el-button>
					<el-button type="primary" @click="submitForm">{{ $t('device.confirm') }}</el-button>
				</template>
			</el-dialog>

			<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
				:page-sizes="[10, 20, 50, 100]" :page-size="formInline.size" layout="total, sizes, prev, pager, next"
				:total="total"></el-pagination>
		</el-card>
	</div>
</template>

<script>
	import goods from '@/model/goods'

	export default {
		data() {
			return {
				formInline: {
					name: '',
					status: '',
					category_id: '',
					page: 1,
					size: 20
				},
				tableData: [],
				total: 0,
				categories: [],
				models: [],
				dialogVisible: false,
				editForm: {
					id: '',
					name: '',
					category_id: '',
					goods_id: 0,
					desc: '',
					card_type_arr: [],
					logo: '',
					file: '',
					video_file: '' // 新增视频文件字段
				},
				cardTypeOptions: [
					{ value: '1', label: this.$t('goods.health_card') },
					{ value: '11', label: this.$t('detail.temp') },
					{ value: '12', label: this.$t('detail.heart') },
					{ value: '13', label: this.$t('detail.blood') },
					{ value: '14', label: this.$t('detail.pressure') },
					{ value: '15', label: this.$t('detail.oxygen') },
					{ value: '16', label: this.$t('detail.step') },
					{ value: '17', label: this.$t('health.sleep') },
					{ value: '2', label: this.$t('goods.location_card') },
					{ value: '21', label: this.$t('goods.voice_call') }
				]
			}
		},
		computed: {
			editTitle() {
				return this.editForm.id ? this.$t('device.edit') : this.$t('goods.add')
			}
		},
		async mounted() {
			await this.getCategories()
			await this.getModels()
			this.search()
		},
		methods: {
			async getCategories() {
				const res = await goods.getCategory({})
				if (res.code === 200) {
					this.categories = res.data.list
				}
			},
			async getModels() {
				const res = await goods.getModelList({ size: 10000 })
				if (res.code === 200) {
					this.models = res.data.list
				}
			},
			async search() {
				const params = {
					...this.formInline,
					card_type: this.formInline.card_type_arr?.join(',')
				}
				const res = await goods.lists(params)
				if (res.code === 200) {
					this.tableData = res.data.list.map(item => ({
						...item,
						status_text: this.getStatusText(item.status),
						card_type_arr: item.card_type?.split(',') || []
					}))
					this.total = res.data.total
				}
			},
			getStatusText(status) {
				const statusMap = {
					1: this.$t('goods.pending'),
					2: this.$t('goods.published'),
					3: this.$t('goods.off')
				}
				return statusMap[status] || ''
			},
			getCardTypeName(type) {
				const item = this.cardTypeOptions.find(opt => opt.value === type)
				return item ? item.label : type
			},
			getSortedCardTypes(arr) {
				if (!arr || arr.length === 0) return []
				return this.cardTypeOptions
					.filter(opt => arr.includes(opt.value))
					.map(opt => opt.value)
			},
			handleEdit(row) {
				this.editForm = row.id ? {
						...row,
						card_type_arr: row.card_type?.split(',') || [],
						goods_id: row.goods_id || 0
					} :
					{
						id: '',
						name: '',
						category_id: '',
						goods_id: 0,
						desc: '',
						card_type_arr: [],
						logo: '',
						file: '',
						video_file: '' // 确保新增时也有该字段
					}
				this.dialogVisible = true
			},
			async toggleStatus(row) {
				const newStatus = row.status === 2 ? 3 : 2
				const res = await goods.status({
					id: row.id,
					status: newStatus
				})
				if (res.code === 200) {
					this.search()
				}
			},
			handleLogoUpload(response) {
				this.editForm.logo = response.data
			},
			handleFileUpload(response) {
				this.editForm.file = response.data
			},
			// 新增视频文件上传处理方法
			handleVideoFileUpload(response) {
				this.editForm.video_file = response.data
			},
			reset() {
				this.formInline.category_id = '';
				this.formInline.status = '';
				this.formInline.name = '';
				this.search();
			},
			async submitForm() {
				const params = {
					...this.editForm,
					card_type: this.editForm.card_type_arr.join(',')
				}
				const res = await goods.operate(params)
				if (res.code === 200) {
					this.dialogVisible = false
					this.search()
				} else {
					this.$message.error(res.message)
				}
			},
			handleCurrentChange(page) {
				this.formInline.page = page
				this.search()
			},
			handleSizeChange(size) {
				this.formInline.size = size
				this.formInline.page = 1
				this.search()
			}
		}
	}
</script>